import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BaseChartDirective } from 'ng2-charts';

import { CustomerAdminOverviewPageRoutingModule } from './customer-admin-overview-routing.module';
import { CustomerAdminOverviewPage } from './customer-admin-overview.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BaseChartDirective,
    NgxDatatableModule,
    CustomerAdminOverviewPageRoutingModule,
  ],
  declarations: [CustomerAdminOverviewPage],
})
export class CustomerAdminOverviewPageModule {}
